import branch from 'branch-sdk';
import { getBranchKey } from 'utils';

const WbBranchIo = function BranchIo() {
  const branchKey = getBranchKey();
  branch.init(branchKey, new Option(), (err: any, data: any) => {});
  return <div />;
};

export default WbBranchIo;
